module.exports = __webpack_public_path__ + "img/制御工学3_5_2.d9c74239.png";